// import {Inject, Injectable, Renderer2} from '@angular/core';
// import {AngularFireAuth} from "@angular/fire/compat/auth";
// import {NgZone} from '@angular/core';
// import {Router} from '@angular/router';
// import firebase from "firebase/compat/app";
// import {Observable} from "rxjs";
// import {AngularFireDatabase} from "@angular/fire/compat/database";
// import {UserRole} from "./components/rename/add-user-role/add-user-role.component";
// import {Employee} from "./interfaces/Employee";
// import {LogService} from "./services/log.service";
// import {firstValueFrom} from 'rxjs';
// import {switchMap} from "rxjs/operators";
// import {MatSnackBar} from "@angular/material/snack-bar";
// import {FirebaseErrors} from "./FirebaseErrors";
// import {AngularFireFunctions} from "@angular/fire/compat/functions";
// import {getFunctions, httpsCallable} from '@angular/fire/functions';
//
// export interface UserData {
//   centreCode: string;
//   email: string;
//   role: string;
//   uid: string;
//   userName: string;
//   id: string;
//   centre: string;
//   department: string;
//   empCode: number;
//   jobtitle: string;
//   location: string;
//   mobile: number;
//   permissions?: UserRole[];
//   centresAllowed: string[];
// }
//
// @Injectable({
//   providedIn: 'root',
// })
// export class AuthService {
//   roleAs = '';
//   userEmail = '';
//   userData$: Observable<any>;
//   user$: Observable<firebase.User | null>;
//   userData: any
//   permissions: UserRole[] = [];
//
//   constructor(public mAuth: AngularFireAuth,
//               public router: Router,
//               private mDatabase: AngularFireDatabase,
//               public functions: AngularFireFunctions,
//               public ngZone: NgZone,
//               private mLogService: LogService,
//               private readonly _snackBar: MatSnackBar) {
//     this.user$ = mAuth.authState;
//
//
//     this.userData$ = this.user$.pipe(
//       switchMap((user) =>
//         user
//           ? this.mDatabase.object('users/' + user.uid).valueChanges()
//           : []
//       )
//     );
//   }
//
//   async SignIn(email: string, password: string) {
//     localStorage.clear()
//     try {
//       const userCredential = await this.mAuth.signInWithEmailAndPassword(
//         email,
//         password
//       ).catch(err => {
//         this._snackBar.open('Invalid Username Or Password')._dismissAfter(3000)
//         console.log('Something went wrong:', FirebaseErrors.Parse(err.message));
//       });
//       if (userCredential && userCredential.user) {
//         console.log('Login is Successful')
//         const user = userCredential.user;
//         localStorage.setItem('user', JSON.stringify(user));
//         localStorage.setItem('uid', user.uid);
//         localStorage.setItem('userEmail', user.email!);
//         this.userEmail = localStorage.getItem('userEmail')!;
//         let activity = {
//           date: new Date().getTime(),
//           section: 'Login',
//           action: 'Login',
//           user: this.userEmail,
//           description: 'Login by user ' + this.userEmail,
//           currentIp: localStorage.getItem('currentip')!,
//         };
//         await this.setUserData(user.uid)
//
//         await this.mLogService.addLog(activity);
//         console.log('flow complete')
//       }
//
//     } catch (err: any) {
//       this._snackBar.open('Invalid password')._dismissAfter(3000)
//       console.log('Something went wrong:', FirebaseErrors.Parse(err.message));
//     }
//   }
//
//   async SignOut() {
//     let activity = {
//       date: new Date().getTime(),
//       section: 'Logout',
//       action: 'Logout',
//       description: 'Logout by user ',
//       currentIp: localStorage.getItem('currentip')!,
//     };
//     await this.mLogService.addLog(activity);
//     try {
//       await this.mAuth.signOut();
//       localStorage.clear();
//       this.router.navigate(['login']);
//       console.log('Logged out!');
//     } catch (err) {
//       console.log('Error while signing out:', err);
//     }
//   }
//
//   get isLoggedIn(): boolean {
//     const user = JSON.parse(localStorage.getItem('user') || '{}');
//     return user !== null;
//   }
//
//   async setUserData(uid: string) {
//     try {
//       this.mDatabase
//         .object<UserData>('users/' + uid)
//         .valueChanges().subscribe(res => {
//         let userData = res
//         localStorage.setItem('userData', JSON.stringify(userData));
//
//         const resdata = userData as UserData;
//         if (resdata.role) {
//           localStorage.setItem('ROLE', resdata.role);
//         }
//
//         if (resdata.permissions) {
//           localStorage.setItem('permissions', JSON.stringify(resdata.permissions));
//         }
//
//         this.router.navigate(['home/dashboard']).then(() => {
//           console.log('sending to dashboard');
//         })
//       })
//     } catch (error) {
//       console.error(error);
//     }
//   }
//
//   getRole() {
//     this.roleAs = localStorage.getItem('ROLE') || '';
//     return this.roleAs;
//   }
//
//   changePassword(email: string): Promise<void> {
//     return this.mAuth.sendPasswordResetEmail(email);
//   }
//
//   getPermissions(uid: string) {
//     this.mDatabase
//       .list<Employee>('users/' + uid)
//       .snapshotChanges()
//       .subscribe((res) => {
//         res.forEach((r) => {
//           let e = r.payload.toJSON() as Employee;
//           this.permissions = e.permissions!;
//           localStorage.setItem('permissions', JSON.stringify(this.permissions));
//         });
//       });
//   }
//
//   async changePasswordOfAnotherUser(uid: string, password: string) {
//     const functions = getFunctions(undefined, 'us-central1'); // Specify the region
//     const changePasswordCallable = httpsCallable(functions, 'changePassword2'); // Use the modular httpsCallable
//     try {
//       // Ensure we have a fresh token
//       const user = await this.mAuth.currentUser;
//       if (user) {
//         await user.getIdToken(true); // Force refresh token
//       }
//
//       const result = await changePasswordCallable({uid, newPassword: password}); // Await the promise directly
//       console.log('Password changed successfully', result);
//       this._snackBar.open('Password changed successfully')._dismissAfter(3000);
//     } catch (error) {
//       console.error('Error changing password', error);
//       this._snackBar.open('Error changing password')._dismissAfter(3000);
//     }
//   }
// }

import {Inject, Injectable, Renderer2} from '@angular/core';
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {NgZone} from '@angular/core';
import {Router} from '@angular/router';
import firebase from "firebase/compat/app";
import {Observable} from "rxjs";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {UserRole} from "./components/rename/add-user-role/add-user-role.component";
import {Employee} from "./interfaces/Employee";
import {LogService} from "./services/log.service";
import {firstValueFrom} from 'rxjs';
import {map, switchMap} from "rxjs/operators";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FirebaseErrors} from "./FirebaseErrors";
import {AngularFireFunctions} from "@angular/fire/compat/functions";
import {getFunctions, httpsCallable} from '@angular/fire/functions';

export interface UserData {
  centreCode: string;
  email: string;
  role: string;
  uid: string;
  userName: string;
  id: string;
  centre: string;
  department: string;
  empCode: number;
  jobtitle: string;
  location: string;
  mobile: number;
  permissions?: UserRole[];
  centresAllowed: string[];
  isDepartmentHead?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  roleAs = '';
  userEmail = '';
  userData$: Observable<any>;
  user$: Observable<firebase.User | null>;
  userData: any
  permissions: UserRole[] = [];

  constructor(public mAuth: AngularFireAuth,
              public router: Router,
              private mDatabase: AngularFireDatabase,
              public functions: AngularFireFunctions,
              public ngZone: NgZone,
              private mLogService: LogService,
              private readonly _snackBar: MatSnackBar) {
    this.user$ = mAuth.authState;

    this.userData$ = this.user$.pipe(
      switchMap((user) =>
        user
          ? this.mDatabase.object('users/' + user.uid).valueChanges()
          : []
      )
    );
  }

  async SignIn(email: string, password: string) {
    localStorage.clear();

    try {
      // Show loading message
      const loadingSnack = this._snackBar.open('Connecting...', 'LOADING', {duration: 0});

      const userCredential = await this.mAuth.signInWithEmailAndPassword(
        email,
        password
      ).catch(err => {
        loadingSnack.dismiss();
        this._snackBar.open('Invalid Username Or Password', 'ERROR', {duration: 3000});
        console.log('Something went wrong:', FirebaseErrors.Parse(err.message));
        throw err;
      });

      if (userCredential && userCredential.user) {
        console.log('✅ Authentication successful');
        const user = userCredential.user;
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('uid', user.uid);
        localStorage.setItem('userEmail', user.email!);
        this.userEmail = localStorage.getItem('userEmail')!;

        let activity = {
          date: new Date().getTime(),
          section: 'Login',
          action: 'Login',
          user: this.userEmail,
          description: 'Login by user ' + this.userEmail,
          currentIp: '', // Will be set by LogService
        };

        // Set user data first
        await this.setUserData(user.uid);

        // Try to add log - this will WAIT for valid IP
        try {
          console.log('📝 Recording login activity...');
          loadingSnack.dismiss();
          const recordingSnack = this._snackBar.open('Recording activity...', 'PLEASE WAIT', {duration: 0});

          await this.mLogService.addLog(activity);

          recordingSnack.dismiss();
          console.log('✅ Login activity recorded successfully');
          this._snackBar.open('Login successful!', 'SUCCESS', {duration: 2000});

        } catch (logError: any) {
          loadingSnack.dismiss();
          console.error('❌ Failed to record login activity:', logError);
          this._snackBar.open(
            logError.message || 'Failed to record activity. Please check your connection.',
            'ERROR',
            {duration: 5000}
          );
          // Don't proceed if logging fails
          throw logError;
        }

        console.log('✅ Login flow complete');
      }

    } catch (err: any) {
      console.error('❌ Login failed:', err);
      throw err;
    }
  }

  async SignOut() {
    let activity = {
      date: new Date().getTime(),
      section: 'Logout',
      action: 'Logout',
      description: 'Logout by user ',
      currentIp: '', // Will be set by LogService
    };

    try {
      // Show recording message
      const recordingSnack = this._snackBar.open('Recording logout...', 'PLEASE WAIT', {duration: 0});

      // Try to log the logout activity - WAITS for valid IP
      await this.mLogService.addLog(activity);

      recordingSnack.dismiss();
      console.log('✅ Logout activity recorded');

    } catch (logError: any) {
      console.error('❌ Failed to record logout activity:', logError);
      this._snackBar.open(
        'Warning: Unable to record logout activity',
        'WARNING',
        {duration: 3000}
      );
    }

    try {
      await this.mAuth.signOut();
      localStorage.clear();
      this.router.navigate(['login']);
      console.log('✅ Logged out successfully');
    } catch (err) {
      console.error('❌ Error while signing out:', err);
    }
  }

  /**
   * The only place the identity keys are written. `userData` alone is read from
   * localStorage in ~130 places, so every one of these has to be in step.
   */
  private cacheUserData(res: UserData | null, user: firebase.User): UserData | null {
    if (!res) {
      return null;
    }
    // The record itself can carry a stale `uid` field (e.g. left over from
    // account recreation); the auth uid used to fetch it is authoritative,
    // so it must win over whatever is stored inside the record.
    const userData = {...res, uid: user.uid} as UserData;

    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('uid', user.uid);
    if (user.email) {
      localStorage.setItem('userEmail', user.email);
    }
    localStorage.setItem('userData', JSON.stringify(userData));

    if (userData.role) {
      localStorage.setItem('ROLE', userData.role);
    }

    if (userData.permissions) {
      localStorage.setItem('permissions', JSON.stringify(userData.permissions));
    }

    return userData;
  }

  /**
   * Refill the identity keys for an already-signed-in user. Firebase restores the
   * session by itself on reload, but `userData` was only ever written during
   * SignIn — so without this a restored session boots with an empty cache and
   * every consumer of it breaks.
   */
  async hydrateUserData(user: firebase.User): Promise<UserData | null> {
    try {
      const res = await firstValueFrom(
        this.mDatabase.object<UserData>('users/' + user.uid).valueChanges()
      );
      return this.cacheUserData(res, user);
    } catch (error) {
      console.error('Failed to load user record for ' + user.uid, error);
      return null;
    }
  }

  /**
   * Keeps the cached identity keys in step with the user record for as long as the
   * session lasts, so a permission change lands without a re-login.
   */
  watchUserData(user: firebase.User): Observable<UserData | null> {
    return this.mDatabase
      .object<UserData>('users/' + user.uid)
      .valueChanges()
      .pipe(map(res => this.cacheUserData(res, user)));
  }

  async setUserData(uid: string) {
    try {
      const user = await this.mAuth.currentUser;
      if (!user) {
        return;
      }
      this.mDatabase
        .object<UserData>('users/' + uid)
        .valueChanges().subscribe(res => {
        this.cacheUserData(res, user);

        this.router.navigate(['home/dashboard']).then(() => {
          console.log('sending to dashboard');
        })
      })
    } catch (error) {
      console.error(error);
    }
  }

  getRole() {
    this.roleAs = localStorage.getItem('ROLE') || '';
    return this.roleAs;
  }

  changePassword(email: string): Promise<void> {
    return this.mAuth.sendPasswordResetEmail(email);
  }

  getPermissions(uid: string) {
    this.mDatabase
      .list<Employee>('users/' + uid)
      .snapshotChanges()
      .subscribe((res) => {
        res.forEach((r) => {
          let e = r.payload.toJSON() as Employee;
          this.permissions = e.permissions!;
          localStorage.setItem('permissions', JSON.stringify(this.permissions));
        });
      });
  }

  async changePasswordOfAnotherUser(uid: string, password: string) {
    const functions = getFunctions(undefined, 'us-central1');
    const changePasswordCallable = httpsCallable(functions, 'changePassword2');
    try {
      const user = await this.mAuth.currentUser;
      if (user) {
        await user.getIdToken(true);
      }

      const result = await changePasswordCallable({uid, newPassword: password});
      console.log('Password changed successfully', result);
      this._snackBar.open('Password changed successfully', 'SUCCESS', {duration: 3000});
    } catch (error) {
      console.error('Error changing password', error);
      this._snackBar.open('Error changing password', 'ERROR', {duration: 3000});
    }
  }
}
